export const environment = {
  production: false,
  envName: 'development',
  onboardingApiBaseUrl: 'https://unitedteambuildingazfunccore-dev-e8grdjanc8h2exad.centralus-01.azurewebsites.net/api',
  recaptchaSiteKey: '6Le90SQtAAAAAP1se2S1x-supjcE5pgLA7eDi9oR',
  blobPrefix: 'https://unitedteambuildingdev.blob.core.windows.net/site-assets/',
  servicesPage: {
    sectionHowItWorks: {
      path: 'site-pages/services/HowItWorks/',
      webmUrl: 'ServicesCollage.webm'
    }
  },
  legalPage: {
    sectionTermsConditions: {
      path: 'site-pages/legal/TermsConditions/',
      docName: 'TermsConditions.json'
    },
    sectionPrivacyPolicy: {
      path: 'site-pages/legal/PrivacyPolicy/',
      docName: 'PrivacyPolicy.json'
    },
    sectionConsentCommunication: {
      path: 'site-pages/legal/ConsentCommunication/',
      docName: 'ConsentCommunications.json'
    }
  }

};
